var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full mt-[24px]"},[_c('canvas',{staticStyle:{"width":"100%","height":"auto"},attrs:{"id":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }